module.exports = __webpack_public_path__ + "static/media/Nodemon.c3b37eeb.svg";